import { State } from 'src/types'
import { indexFingerPad } from '../indexFingerPad'
import { indexFingerCover } from '../indexFinger'

export const fingerGuardDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  switch (state.fingerGuardType.value) {
    case 'indexCover':
      // 指カバー
      indexFingerCover(ctx, state.indexCover.color, state.stitch.color)
      break
    case 'indexPad':
      // 指当て
      indexFingerPad(ctx, state.indexCover.color, state.stitch.color)
      break
  }
}
